import { DateHelpers } from "../helpers/date-helpers";
import { FormatHelpers } from "../helpers/format-helpers";
import { StringHelpers } from "../helpers/string-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { ChartStyleSettingsModel } from "../models/chart-style/chart-style-settings.model";
import { IComponent } from "./component.interface";
import { BuySellItem, DrawEMACloudBuySellArrowComponent } from "./draw-ema-cloud-buy-sell-arrow.component";
declare const $: any;

export const enum TradeReportType {
    Long = 0,
    Short = 1
}

export class EMACloudBuySellSummaryPopupComponent implements IComponent {
    public id = 'ema-cloud-buy-sell-summary-popup-' + StringHelpers.newGuid();
    
    private element: HTMLElement;
    private base: IChartContainer;
    private dataTable: any;
    private dataSet: Array<BuySellItem> = [];
    private totalProfitPercentage = 0;
    private chartStyle: ChartStyleSettingsModel | null = null;
    private init = false;
    // private animating = false;
    private elementWidth = 0;
    private elementHeight = 0;
    private setSmallerHeight = false;
    private reportType: TradeReportType = null;

    private readonly headerFooterHeight =  94;

    constructor(base: IChartContainer) {
        this.base = base;
        this.onResize();
        this.onBodyClick();
        this.base.chartService.subscribeChartStyleData((chartStyle: ChartStyleSettingsModel) => {
            this.chartStyle = chartStyle;
            if (!this.chartStyle.emaCloudDisplayBuySellFlags) {
                this.close(true);
                return;
            }

            if (!this.init) {
                this.init = true;
                this.create();
                this.onClick();

                this.base.tiChartSeries?.subscribeChartLoad(this.id, () => {
                    setTimeout(() => {
                        this.setElementSize();
                    }, 2000);
                });

                this.base.tiChartSeries?.subscribeRedrawChange(this.id, () => {
                    this.setElementSize();
                });
            }

            if (this.element) {
                if (this.chartStyle.isDarkTheme) {
                    this.element.classList.add('dark');
                } else {
                    this.element.classList.remove('dark');
                }
            }
        });
    }

    public isActive(): boolean {
        return this.element?.classList.contains('active') ?? false;
    }

    public show() {
        const wrapper = this.element?.querySelector<HTMLElement>('.wrapper');
        if (!wrapper) {
            return;
        }

        // this.animating = true;
        // let top = this.getTop();
        this.element?.classList.add('active');

        // this.element.setAttribute('style', `height: 0px !important; width: 550px !important; top: ${top}px !important`);
        // wrapper.setAttribute('style', `height: 0px; overflow: hidden;`);

        this.createTable();

        const done = () => {
            wrapper.setAttribute('style', ``);
            this.setElementSize();
            
            setTimeout(() => {
                if (this.dataTable) {
                    this.dataTable.draw();
                }

                setTimeout(() => {
                    let body = $(this.element).find('.content');
                    if (this.base.marketingWebChartMode) {
                        body = $(this.element).find('.dataTables_scrollBody');
                    }

                    const height = body[0].scrollHeight;
                    $(body).scrollTop(height);
                    // this.animating = false;
                }, 50);
            }, 50);
        };
        

        // let maxHeight = this.elementHeight;
        // this.element.setAttribute('style', `height: ${maxHeight}px !important; width: 550px !important; top: ${top}px !important`);
        done();

        // let currentHeight = 0;
        // let increment = 2;
        // let interval = setInterval(() => {
        //     if (currentHeight >= maxHeight) {
        //         clearInterval(interval);
        //         done();
        //     } else {
        //         currentHeight += increment;
        //         top -= increment;

        //         this.element.setAttribute('style', `height: ${currentHeight}px !important; width: 550px !important; top: ${top}px !important`);
        //         wrapper.setAttribute('style', `height: ${currentHeight}px; overflow: hidden;`);
        //     }
        // }, 5);
    }

    public close(forceHide?: boolean) {
        if (!this.element) return;

        if (forceHide) {
            this.reportType = null;
            this.dataSet = [];
            this.element.classList.add('hidden');
            this.base.chartWrapper.querySelectorAll<HTMLElement>('.tf.ema a').forEach((el: HTMLElement) => {
                el.classList.add('hidden');
            });
        }

        this.element.classList.remove('active');
        this.setElementSize();

        this.setPauseIconColor();
    }

    public setData(reportType: TradeReportType | null, data: Array<BuySellItem>, totalProfit: number) {
        this.dataSet = data;
        this.totalProfitPercentage = totalProfit;
        let isActive = false;
        this.base.chartWrapper.querySelectorAll<HTMLElement>('.tf.ema').forEach((el: HTMLElement) => {
            isActive = el.classList.contains('active');

            const aHref = el.querySelector(`a`);
            if (aHref) {
                if (!this.chartStyle.emaCloudDisplayBuySellFlags) {
                    aHref.classList.remove('hidden');
                } else {
                    aHref.classList.add('hidden');
                }
            }
        });

        if (isActive && this.chartStyle.emaCloudDisplayBuySellFlags) { 
            this.element?.classList.remove('hidden');
        } else {
            this.element?.classList.add('hidden');
        }
       
        if (reportType != null) {
            this.setOption(reportType);
            if (this.reportType != reportType) {
                this.reportType = reportType;
                this.createTable();
            }
        }

        this.setPauseIconColor();
    }

    private setPauseIconColor() {
        const pauseIcon = this.element.querySelector('.on-off-arrow');
        if (pauseIcon) {
            pauseIcon.classList.remove('red');
            pauseIcon.classList.remove('green');

            if (this.reportType == TradeReportType.Long) {
                pauseIcon.classList.add('green');
            } else if (this.reportType == TradeReportType.Short) {
                pauseIcon.classList.add('red');
            }
        }
    }

    private createTable() {
        if (!this.element) return;
        const rowData: Array<any> = [];

        for (const d of this.dataSet) {
            const row = [
                d.isLong,
                d.entryBarDate,
                d.entryBarPrice == null ? '' : '$' + FormatHelpers.numberToString(d.entryBarPrice, 2),
                d.exitBarDate,
                d.exitBarPrice == null ? '' : '$' + FormatHelpers.numberToString(d.exitBarPrice, 2),
                d.profitPercentage,
                d.openProfitPercentage,
            ];

            rowData.push(row);
        }

        if (this.dataTable) {
            this.dataTable.destroy();
        }

        let ordering = true;
        if (window.matchMedia('(max-width: 768px)').matches) {
            ordering = false;
        }
        this.dataTable = $('#ema-summary-table').DataTable({
            searching: false,
            bLengthChange: false,
            ordering: ordering,
            bInfo: false,
            paging: false,
            autoWidth: false,
            scrollX: true,
            scrollY: this.setSmallerHeight ? 'auto' : 160,
            columns: [
                {
                    title: 'Side', width: '5%',
                    class: 'side',
                    render: function (data, type, row, meta) {
                        if (data == null) return ``;
                        return data == true ? 'Long' : 'Short';
                    }
                },
                {
                    title: 'Entry Date', width: '10%',
                    render: function (data, type, row, meta) {
                        if (data == null) return ``;
                        return `
                        <span title="${DateHelpers.format('mm/dd/yyyy HH:MM tt', data)}">
                            ${DateHelpers.format('mm/dd', data)}</span>
                        `;
                    }
                },
                { title: 'Entry Price', width: '12%' },
                {
                    title: 'Exit Date', width: '10%',
                    render: function (data, type, row, meta) {
                        if (data == null) return ``;
                        return `
                        <span title="${DateHelpers.format('mm/dd/yyyy HH:MM tt', data)}">
                            ${DateHelpers.format('mm/dd', data)}
                        </span>`;
                    }
                },
                { title: 'Exit Price', width: '12%' },
                {
                    title: 'Closed Profit', width: '10%',
                    render: function (data, type, row, meta) {
                        if (data == null) return ``;
                        return `
                        <span class="${data >= 0 ? 'green' : 'red'}">
                            ${FormatHelpers.numberToString(data, 2) + '%'}
                        </span>`;
                    }
                },
                {
                    title: 'Open Profit', width: '10%',
                    render: function (data, type, row, meta) {
                        if (data == null) return ``;
                        return `
                        <span class="${data >= 0 ? 'green' : 'red'}">
                            ${FormatHelpers.numberToString(data, 2) + '%'}
                        </span>`;
                    }
                },
            ],
            data: rowData
        });

        let profitString = FormatHelpers.numberToString(Math.abs(this.totalProfitPercentage), 2);
        const positive = this.totalProfitPercentage >= 0 || profitString == '0';
        $(this.element).find('.total-profit').html(`${rowData.length} Trades, Total Profit: <span class="${positive ? '' : 'neg'}">${(positive ? '' : '-') + profitString + '%'}</span>`);
    }

    private onClick() {
        this.element?.querySelectorAll<HTMLElement>('.on-off-arrow').forEach((el: HTMLElement) => {
            el.addEventListener('click', () => {
                if (!this.isActive()) {
                    this.show();
                } else {
                    this.close();
                }
            });
        });
    }

    private create() {
        if (!this.chartStyle) return;

        const div = document.createElement('div');
        div.className = `ema-summary-popup hidden settings-popup ${this.chartStyle.isDarkTheme ? 'dark' : ''} ${this.base.marketingWebChartMode ? '' : 'ti-pro'}`;
        div.innerHTML = `
        <div class="on-off-arrow">
            <div class="pause">
            </div>
            <p class="title">${this.chartStyle.tradeWaveName} Report</p>
        </div>
        <div class="wrapper">
            <div class="head">   
                <p class="title">${this.chartStyle.tradeWaveName} Trade Summary</p>
                <div class="right">
                    <span class="label-inline">Direction:</span>
                    <div class="font-size-picker-wrapper trade-type-picker">
                        <div class="font-size-picker">
                            <div class="selected">
                                <p class="green">Long</p>
                            </div>
                            <div class="arrow">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 7" width="11" height="7" fill="none">
                                    <path stroke="currentColor" stroke-width="1.3" d="M.5 1.5l5 4 5-4"></path>
                                </svg>
                            </div>
                            <ul class="selection">
                                <li data-value="0" class="selected green">Long</li>
                                <li data-value="1" class="red">Short</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <button class="close" type="button" style="opacity: 0; visibility: hidden;">
                    <span class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" width="17" height="17" fill="currentColor">
                            <path d="m.58 1.42.82-.82 15 15-.82.82z"></path>
                            <path d="m.58 15.58 15-15 .82.82-15 15z"></path>
                        </svg>
                    </span>
                </button>
            </div>
            <div class="content" style="height: 240px;">
                <table id="ema-summary-table" class="cell-border"></table>
            </div>
            <div class="footer">
                <p class="total-profit">Total Profit: <span></span></p>
                <button class="close" style="opacity: 0; visibility: hidden;">Close</button>
            </div>
        </div>
        `;

        this.element = div;

        this.base.element?.insertAdjacentElement('beforeend', this.element);
        setTimeout(() => {
            this.onTradeTypePickerClick();
            this.createTable();
            this.setElementSize();
        }, 200);
    }

    private closeTradePicker() {
        const tradeTypePickerElement = this.element?.querySelector('.trade-type-picker');
        if (tradeTypePickerElement) {
            tradeTypePickerElement.classList.remove('active');
        }
    }

    private onTradeTypePickerClick() {
        const tradeTypePickerElement = this.element?.querySelector('.trade-type-picker');
        if (tradeTypePickerElement) {
            tradeTypePickerElement.addEventListener('click', () => {
                tradeTypePickerElement.classList.toggle('active');
            });

            tradeTypePickerElement.querySelectorAll<HTMLElement>('li').forEach((li: HTMLElement) => {
                li.addEventListener('click', () => {
                    const value = parseInt(li.getAttribute('data-value') ?? '', 10) as TradeReportType;
                    if (this.reportType != value) {
                        this.setOption(value);
                        (this.base.getComponentsByType(DrawEMACloudBuySellArrowComponent)?.[0] as DrawEMACloudBuySellArrowComponent)?.draw(value);
                    }
                });
            });
        }
    }

    private setOption(type: TradeReportType) {
        const tradeTypePickerElement = this.element?.querySelector('.trade-type-picker');
        const li = tradeTypePickerElement?.querySelector('li[data-value="' + type + '"]');
        if (!tradeTypePickerElement || !li) { return }

        const label = tradeTypePickerElement.querySelector('.selected p');
        if (label) {
            label.classList.remove('green');
            label.classList.remove('red');
            if (li.classList.contains('green')) {
                label.classList.add('green');
            } else {
                label.classList.add('red');
            }

            label.innerHTML = li.innerHTML;
        }
    }

    private setElementSize() {
        // if (!this.element || this.animating) {
        if (!this.element) {
            return;
        }

        this.elementWidth = this.base.element.clientWidth;

        const elementHeight = 350;
        if (this.elementWidth > 550) {
            this.elementWidth = 550;
        }

        let chartHeight =  this.getHeight();
        this.setSmallerHeight = false;
        if (this.base.isExtraSmall() && elementHeight + 50 > chartHeight) {
            this.elementHeight = chartHeight - 50;
            this.setSmallerHeight = true;
        } else if (this.base.marketingWebChartMode && elementHeight + 25 > chartHeight) {
            this.elementHeight = chartHeight - 25;
            this.setSmallerHeight = true;
        } else {
            this.elementHeight = elementHeight;
        }

        this.element.setAttribute('style', `
            top: ${this.getTop()}px !important;
            width: ${this.elementWidth}px !important;
            ${!this.isActive() ? `height: 0px !important;` : `height: ${this.elementHeight}px !important;`}
        `);

        // this.element.setAttribute('style', `
        //     top: ${this.getTop()}px !important;
        //     width: ${this.elementWidth}px !important;
        //     ${setHeight ? `max-height: ${this.elementHeight}px !important;` : ''}
        //     ${!this.isActive() ? `height: 0px !important;` : ``}
        // `);

        const contentElement = this.element.querySelector<HTMLElement>('.content');
        if (contentElement) {
            if (this.setSmallerHeight) {
                contentElement.setAttribute('style', `height: ${this.elementHeight - this.headerFooterHeight}px !important;`);
            } else {
                contentElement.setAttribute('style', '');
            }
        }
    }

    private getTop(): number {
        let height = this.getHeight();
        if (this.isActive()) {
            height -= this.elementHeight;
        }

        return height;
    }

    private getHeight(): number {
        let height = this.base.tiChartSeries.highChartBuilder.getXAxisTop();

        height += this.base.tiChartSeries.element.querySelector<HTMLElement>('.chart-container')?.offsetTop ?? 0;

        return height;
    }

    private resizeTimmer = null as any;
    private onResize() {
        this.base.domEvents.onResize(this.id, () => {
            clearTimeout(this.resizeTimmer);
            this.resizeTimmer = setTimeout(() => {
                this.setElementSize();
            }, 150);
        });
    }

    private onBodyClick() {
        this.base.domEvents.onBodyClick(this.id, (ev: any) => {
            const target = ev.target as HTMLElement;
            if (target.classList.contains('trade-type-picker') || !!target.closest('.trade-type-picker')) {
                return;
            }

            this.closeTradePicker();
        });
    }
}